import styled from "styled-components";


export const BottomDiv=styled.div`
    display:none;
    @media only screen and (max-device-width: 750px){
      display: flex;
      width: 100%;
      position: fixed;
      bottom: 0px;
      //backdrop-filter: invert(25%);  
     // padding: 15px 5px 15px 15px;
      padding: 15px 10px 10px;
      background-color: ${({nobg}) => (nobg ? "unset":"white")};      // added for mobile responsive
      justify-content: space-between;
      align-items: end;
      z-index:11;
      border-top: ${({nobg}) => (nobg ? "unset":"1px solid rgba(230, 230, 230, 1);")};
      box-shadow: 3px 3px 3px #333;
  }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
      and (orientation: portrait){
        display: flex;
        width: 100%;
        position: fixed;
        bottom: 0px;
        //backdrop-filter: invert(25%);  
       // padding: 15px 5px 15px 15px;
        padding: 15px 10px 10px;
        background-color: ${({nobg}) => (nobg ? "unset":"white")};      // added for mobile responsive
        justify-content: space-between;
        align-items: end;
        z-index:11;
        border-top: ${({nobg}) => (nobg ? "unset":"1px solid rgba(230, 230, 230, 1);")};
        box-shadow: 3px 3px 3px #333;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
      and (orientation: landscape) and  (-webkit-min-device-pixel-ratio: 2){
        display: flex;
        width: 100%;
        position: fixed;
        bottom: 0px;
        //backdrop-filter: invert(25%);  
       // padding: 15px 5px 15px 15px;
        padding: 15px 10px 10px;
        background-color: ${({nobg}) => (nobg ? "unset":"white")};      // added for mobile responsive
        justify-content: space-between;
        align-items: end;
        z-index:11;
        border-top: ${({nobg}) => (nobg ? "unset":"1px solid rgba(230, 230, 230, 1);")};
        box-shadow: 3px 3px 3px #333;
    }
    // @media only screen and (min-device-width: 992px) and (max-device-width: 1200px){
    //   display:none;
    // }
    
`;
export const StationNameHeader=styled.div`
    display:none;
    @media screen and (max-width: 850px){
        display: ${({show}) => (show ? "flex" : "none")};
        width: 100%;
        position: fixed;
        top: 58px;
        padding-bottom: 5px;
        background-color: white ;
        align-items: center;
        z-index:10;
        justify-content: center;
        font-family: Lato;
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
        text-align: left;

    }
`

export const BottomIcon=styled.img`
    display: none;
    width: 38px;
    height: 38px;
    color: #fff; 
    margin-left: auto;
`;